import Vue from 'vue'
import Router from 'vue-router'
const _import = require('./_import_' + process.env.NODE_ENV)
import { RouteDefines } from '@/utils/defines'
import Login from '@/views/passport/login'

Vue.use(Router)

const routes = [
  // 401
  {
    name: '401',
    path: '/401',
    component: _import('errorpage/401'),
    meta: {
      hasSubMenu: false,
      hidden: true,
      title: '401'
    }
  },
  // 404
  {
    name: '404',
    path: '/404',
    component: _import('errorpage/404'),
    meta: {
      hasSubMenu: false,
      hidden: true,
      title: '404'
    }
  },

  // 登录
  {
    name: RouteDefines.ROUTER_NAME_LOGIN,
    path: '/login',
    component: Login,
    meta: {
      hasSubMenu: false,
      title: '登录',
      icon: 'icon-guanli'
    }
  }
]

const router = new Router({
  routes: routes,
  scrollBehavior: () => ({ y: 0 })
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js